// src/components/PrivateRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, isEmailVerified } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} />;
  }
  if (!isEmailVerified && location.pathname !== '/login') {
    return <Navigate to="/verify-email" state={{ from: location }} />;
  }

  return children;
};

export default PrivateRoute;